import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { 
  Users, 
  FileText, 
  BarChart3, 
  Settings, 
  LogOut, 
  Database,
  Activity,
  MessageSquare,
  Shield,
  PanelLeftClose,
  Import,
  Bell,
  UserPlus
} from "lucide-react"
import { useAuth } from "@/contexts/AuthContext"
import { useNavigate } from "react-router-dom"

export function AdminSidebar() {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    logout(() => navigate('/login'))
  }

  const menuItems = [
    {
      title: "Client Overview",
      icon: Users,
      onClick: () => navigate("/admin"),
      description: "Manage and monitor all client accounts"
    },
    {
      title: "All Clients",
      icon: UserPlus,
      onClick: () => navigate("/admin/all-clients"),
      description: "View complete list of all clients"
    },
    {
      title: "Notifications",
      icon: Bell,
      onClick: () => navigate("/admin/notifications"),
      description: "Manage client notifications"
    },
    {
      title: "Document Center",
      icon: FileText,
      onClick: () => navigate("/admin/documents"),
      description: "Manage system-wide documentation"
    },
    {
      title: "Case Analytics",
      icon: Activity,
      onClick: () => navigate("/admin/analytics"),
      description: "Track active cases and performance"
    },
    {
      title: "Lead Management",
      icon: Database,
      onClick: () => navigate("/admin/leads"),
      description: "Monitor Facebook leads and conversions"
    },
    {
      title: "Import HubSpot Data",
      icon: Import,
      onClick: () => navigate("/admin/import"),
      description: "Import historic client data from HubSpot"
    },
    {
      title: "Performance Metrics",
      icon: BarChart3,
      onClick: () => navigate("/admin/metrics"),
      description: "View system-wide analytics"
    },
    {
      title: "Support Requests",
      icon: MessageSquare,
      onClick: () => navigate("/admin/support"),
      description: "Handle client support tickets"
    },
    {
      title: "System Settings",
      icon: Settings,
      onClick: () => navigate("/admin/settings"),
      description: "Configure system preferences"
    },
  ]

  return (
    <Sidebar className="min-w-[240px] max-w-[240px] border-r border-gray-200 dark:border-gray-800 mt-16">
      <SidebarContent>
        <SidebarGroup>
          <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200 dark:border-gray-800">
            <div className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/2bc37f54-e3ad-4f44-b595-087cdacfda8f.png" 
                alt="Tradeco Logo" 
                className="h-8 w-auto"
              />
            </div>
            <SidebarTrigger>
              <PanelLeftClose className="h-5 w-5" />
            </SidebarTrigger>
          </div>
          <div className="h-[calc(100vh-8rem)] overflow-y-auto pt-6">
            <SidebarGroupContent className="px-2">
              <SidebarMenu>
                {menuItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton 
                      tooltip={item.description}
                      onClick={item.onClick}
                      className="w-full text-left flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
                    >
                      <item.icon className="w-4 h-4 flex-shrink-0" />
                      <span className="truncate text-sm">{item.title}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
                <SidebarMenuItem>
                  <SidebarMenuButton 
                    onClick={handleLogout}
                    tooltip="Sign out of admin console" 
                    className="w-full text-left flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors text-red-500 hover:text-red-600"
                  >
                    <LogOut className="w-4 h-4 flex-shrink-0" />
                    <span className="truncate text-sm">Sign Out</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </SidebarMenu>
            </SidebarGroupContent>
          </div>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
